export default __webpack_public_path__ + "static/5-f17b8fdec0a8bfe15302ab8d7b1f5f54.png";